<notify-popup *ngIf="guestRegistration" (onChanged)="registerNow($event)" [cancelLabel]="'Common.Cancel' | translate"
  [okLabel]="'Common.RegisterNow' | translate" [title]="guestRegistration === 'evaluate' ? ('VacancyTalentInfo.EvaluateMatch' | translate) : ('VacancyTalentInfo.ApplyForVacancy' | translate)"
  [msg]="'VacancyTalentInfo.UnlockPreciseJobMatches' | translate">
</notify-popup>

<div class="vt-info__whatsapp-backdrop" *ngIf="showWhatsappPopup" (click)="closeWhatsappPopup()"></div>
<div class="vt-info__whatsapp-modal" *ngIf="showWhatsappPopup" role="dialog" aria-modal="true">
  <div class="vt-info__whatsapp-modal__header">
    <div class="vt-info__whatsapp-modal__title">
      <i class="app-ico app-ico__social-whatsapp"></i>
      {{ 'WhatsApp.OpenTitle' | translate }}
    </div>
    <button type="button" class="vt-info__whatsapp-modal__close" (click)="closeWhatsappPopup()" [attr.aria-label]="'Common.Close' | translate">
      <i class="app-ico-mask app-ico-mask__x"></i>
    </button>
  </div>
  <textarea
    class="vt-info__whatsapp-modal__message"
    [(ngModel)]="whatsappMessage"
    [disabled]="viewingPhone"
    [attr.aria-label]="'WhatsApp.MessageLabel' | translate">
  </textarea>
  <div class="vt-info__whatsapp-modal__actions">
    <button type="button" class="is-btn is-btn__outfill" (click)="closeWhatsappPopup()">{{ 'Common.Cancel' | translate }}</button>
    <button type="button" class="is-btn" [disabled]="viewingEmail || viewingPhone || copyingContact" [attr.aria-busy]="viewingPhone" (click)="openWhatsapp()">
      <span role="status" aria-live="polite">{{ viewingPhone ? 'Please wait ...' : ('WhatsApp.OpenAction' | translate) }}</span>
    </button>
  </div>
  <p *ngIf="contactError" class="contact-reveal-error" role="alert">{{ contactError }}</p>
</div>

<div class="vt-info" [resizeListener]="{ width: 400, class: 'vt-info-narrow' }">
  <div class="vt-info__inner" [class.is-scroll]="enableScroll">
    <h1 *ngIf="publicView" wordWrap>
      <ng-container *ngIf="isVacancy">
        {{ data.jobName ? data.jobName : data.jobPosition }}, {{ data?.company && data?.company.name ?
        data?.company.name : '' }}
      </ng-container>
      <ng-container *ngIf="!isVacancy">
        {{ data.jobTitle }}, {{ data.name }}
      </ng-container>
    </h1>
    
       
    
    <h2 *ngIf="isVacancy && data.company">
      {{ data.company && data.company.name ? data.company.name : '' }}
    </h2>
 
    <div class="vt-info__profile">
      <div class="vt-info__avatar" [avatarImage]="!isVacancy 
          ? data.avatar
          : data?.company && data?.company.logo 
            ? data?.company.logo 
            : data.hm && data.hm.avatar 
              ? data.hm.avatar 
              : null" [avatarTitle]="!isVacancy
          ? data.name
          : data?.company && data?.company.name
            ? data.company.name
            : data.hm && data.hm.name
              ? data.hm.name
              : null">
      </div>
      <div class="vt-info__status">
        <h2 *ngIf="!isVacancy">{{ data.name }}</h2>
        <h4 *ngIf="data.jobPosition" wordWrap>
          {{ data.jobName ? data.jobName : data.jobPosition }}
        </h4>
        <h4 *ngIf="data.jobTitle" wordWrap>
          {{ data.jobTitle }}
        </h4>
        <div class="vt-info__badges">
          <badges-count
            *ngIf="(validatedJobTitles && validatedJobTitles.length) || (validatedSkills && validatedSkills.length)"
            [validJobTitles]="validatedJobTitles" [validSkills]="validatedSkills">
          </badges-count>
          <!-- <i class="app-ico app-ico__job-title-valid"></i>
          <i class="app-ico app-ico__skill-valid"></i> -->
        </div>
        <div class="subtext" *ngIf="isVacancy && data.hm && data.hm.name" wordWrap>
          {{ data.hm.name }}<span *ngIf="data.hm.name && data.hm.jobPosition">,</span> {{ data.hm.jobPosition ?
          data.hm.jobPosition : '' }}
        </div>
      </div>
    </div>
    <div class="vt-info__details" *ngIf="data.about?.objective">
    <div [innerHTML]="data.about?.objective"></div>
    </div>

    <div class="vt-info__details" *ngIf="isVacancy && data.company">
      <div class="vt-info__details__item"
        *ngIf="data.company && data.company.location && (data.company.location.city || data.company.location.country)">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__location"></i>{{ 'VacancyTalentInfo.MainOfficeLocation' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.company.location.city }}<span *ngIf="data.company.location.city && data.company.location.country">,
          </span>
          {{ data.company.location.country }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.company.type">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__work"></i>{{ 'VacancyTalentInfo.CompanyType' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.company.type }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.company.domain">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__domain"></i>{{ 'VacancyTalentInfo.CompanyDomain' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.company.domain }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.company.size">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__company-size"></i>{{ 'VacancyTalentInfo.CompanySize' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.company.size }}
        </div>
      </div>
    </div>

    <div class="vt-info__match no-link" *ngIf="matchScore">
      <round-progress [score]="matchScore"></round-progress>
      <div class="vt-info__match__section">
        <div class="vt-info__match__title">{{ 'VacancyTalentInfo.MatchLevel' | translate }}</div>
        <div class="vt-info__match__text">{{ 'VacancyTalentInfo.MatchLevelFrozen' | translate }}</div>
      </div>
    </div>
    <div class="vt-info__match" *ngIf="guestMode" (click)="applyRegistration('evaluate')">
      <round-progress [score]="guestScore" [smooth]="true"></round-progress>
      <div class="vt-info__match__section">
        <div class="vt-info__match__title">{{ 'VacancyTalentInfo.EvaluateMatch' | translate }}</div>
        <div class="vt-info__match__text">{{ 'VacancyTalentInfo.DetailedMatch' | translate }}</div>
      </div>
    </div>

    <div class="vt-info__actions" *ngIf="actionsData || guestMode">
      <div class="vt-info__actions__btns">

        <div class="is-btn is-btn is-apply" *ngIf="isVacancy" (click)="onApplyClick()"
          [class.was-applied]="isApplyLoading || (actionsData?.isApplied && !data.applyLink)">
          <i *ngIf="!data.applyLink && actionsData?.isApplied && !actionsData?.cantApply"
            class="app-ico-mask app-ico-mask__checked"></i>
          <i *ngIf="data.applyLink" class="app-ico app-ico__open-in-new"></i>
          <span *ngIf="!isApplyLoading">{{ actionsData?.isApplied ? actionsData?.cantApply ? ('Common.Apply' | translate) : ('Common.Applied' | translate) : ('Common.Apply' | translate) }}          </span>
          <div class="vac-match__loader" @opacityInOut *ngIf="isApplyLoading">
            <div class="round-loader is-trans"></div>
          </div>
        </div>

        <notify-popup
          *ngIf="showApplyPopup"
          (onChanged)="notifyResult($event)"
          [cancelLabel]="'VacancyTalentInfo.ImrpoveMySkills' | translate"
          [okLabel]="'Apply'"
          [msg]="popupMessage" 
          >
        </notify-popup>
        <!-- 
        <div class="is-btn is-btn" *ngIf="!isVacancy" [class.is-btn__outfill]="publicView"
          (click)="contact(actionsData.messageThreadId, actionsData.vacancyId, actionsData.talentId)">
          {{ 'VacancyTalentInfo.ContactTalent' | translate }}
        </div> -->

        <div class="is-btn is-btn__outfill" *ngIf="isVacancy && !data.applyLink"
          (click)="guestMode ? applyRegistration('apply') : contact(actionsData.messageThreadId, actionsData.vacancyId)">
          {{ 'VacancyTalentInfo.AskQuestion' | translate }}
        </div>

        <button
          type="button"
          class="is-btn is-btn__outfill is-whatsapp"
          *ngIf="!isVacancy && !publicView && hasValidWhatsappNumber"
          (click)="openWhatsappPopup($event)"
          [title]="'WhatsApp.OpenTitle' | translate">
          <i class="app-ico app-ico__social-whatsapp"></i>
          <span>{{ 'WhatsApp.OpenShort' | translate }}</span>
        </button>

        <div class="is-btn is-btn__outfill is-share" [class.no-text]="isVacancy"
          [shareUrl]="(isVacancy ? 'v' : 't') + data.publicLinkId">
          <i class="app-ico-mask app-ico-mask__share"></i>
          <span *ngIf="!isVacancy">{{ 'Common.Share' | translate }}</span>
        </div>
      </div>
      <div class="vt-info__actions__text" *ngIf="isVacancy">
        <ng-container *ngIf="!actionsData.isApplied">
          <div *ngIf="(isIncognito$ | async)">
            {{ 'VacancyTalentInfo.DeAnonymizedWarning' | translate }}
          </div>
          <div *ngIf="!actionsData?.cantApply">
            {{ 'VacancyTalentInfo.AskQuestionsBeforeApply' | translate }}
          </div>
        </ng-container>
        <div *ngIf="actionsData?.cantApply && !data.applyLink">
          {{ 'VacancyTalentInfo.JobCategoryMismatch' | translate }}
        </div>
        <div *ngIf="matchInProgress">
          {{ 'VacancyTalentInfo.AnalyzingApplyPossibility' | translate }}
        </div>
      </div>
    </div>

    <div class="vt-info__details" *ngIf="(
        data.location && (data.location.country || data.location.city)
        || (isVacancy && data.salary && (data.salary.amount || data.salary.amountTo))
        || (!isVacancy && (data.salary | salary))
        || (!isVacancy && (data.expectedSalary | salary))
        || data.workPlace
        || data.employmentType
        || data.relocation
        || data.educationDegree || data.educationField
        || (data.languages && data.languages.length && data.languages[0] && data.languages[0].name)
        || (!isVacancy && data.created)
        || (!isVacancy && (data.email || data.phone?.phoneNumber))
        || actionsData
      )">

      <div class="vt-info__details__item" *ngIf="data.jobPosition">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__rocket"></i>{{ 'Common.JobTitle' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.jobPosition }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.jobId">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__search"></i>{{ 'Common.JobId' | translate }}
        </div>
        <div class="vt-info__details__item__value" wordWrap>
          {{ data.jobId }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="!isVacancy && (data.salary | salary) as currentSalary">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__salary"></i>{{ 'VacancyTalentInfo.CurrentSalary' | translate }}
          <span *ngIf="salaryService.isUnverified(data.salary)" class="vt-info__salary-disclaimer">
            <button
              type="button"
              class="vt-info__salary-info"
              [attr.aria-label]="'Common.SalaryUnverified' | translate">
              i
            </button>
            <span class="vt-info__salary-tooltip" role="tooltip">{{ 'Common.SalaryUnverified' | translate }}</span>
          </span>
        </div>
        <div class="vt-info__details__item__value">
          {{ currentSalary }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="isVacancy && data.salary && (data.salary.amount || data.salary.amountTo)">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__salary"></i>{{ 'VacancyTalentInfo.ExpectedSalary' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.salary.currency | currency }}
          <span>{{ data.salary.amount | salaryDivider }}</span>
          <span *ngIf="data.salary.amount && data.salary.amountTo "> - </span>
          <span *ngIf="data.salary.amountTo">{{ data.salary.amountTo | salaryDivider }}</span>
          <span> {{ data.salary.period | salaryPeriod }}</span>
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="!isVacancy && (data.expectedSalary | salary) as expectedSalary">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__salary"></i>{{ 'VacancyTalentInfo.ExpectedSalary' | translate }}
          <span *ngIf="salaryService.isUnverified(data.expectedSalary)" class="vt-info__salary-disclaimer">
            <button
              type="button"
              class="vt-info__salary-info"
              [attr.aria-label]="'Common.SalaryUnverified' | translate">
              i
            </button>
            <span class="vt-info__salary-tooltip" role="tooltip">{{ 'Common.SalaryUnverified' | translate }}</span>
          </span>
        </div>
        <div class="vt-info__details__item__value">
          {{ expectedSalary }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.workPlace">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__home-work"></i>{{ 'VacancyTalentInfo.ExpectedWorkplace' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.workPlace | workplace }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.employmentType">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__employment-type"></i>{{ 'Common.EmploymentType' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.employmentType | employmentType }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.location && (data.location.country || data.location.city)">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__location2"></i>{{ isVacancy ? ('VacancyTalentInfo.VacancyLocation' | translate) : ('VacancyTalentInfo.CurrentLocation' | translate) }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.location.country }}<span *ngIf="data.location.country && data.location.city">, </span>
          {{ data.location.city }}
        </div>
      </div>

      <!-- Contacts Section - Moved here after location -->
      <ng-container *ngIf="!publicView && (data.email || data.phone?.phoneNumber || data.socialMedia?.telegram)">
        <div class="vt-info__details__item contact-row" *ngIf="data.email">
          <div class="vt-info__details__item__title">
            <i class="app-ico-mask app-ico-mask__envelope"></i>{{ 'VacancyTalentInfo.Mail' | translate }}
          </div>
          <div class="vt-info__details__item__value vt-info__details__item__value--mail" [class.is-anonymous]="data.email.includes('[anonymous]')">
            <ng-container *ngIf="!data.email.includes('[anonymous]')">
              <ng-container *ngTemplateOutlet="contactCapsule; context: {
                detail: 'email', label: 'Email address', value: data.email,
                viewed: data.isEmailViewed !== false, loading: viewingEmail
              }"></ng-container>
            </ng-container>
            <span *ngIf="data.email.includes('[anonymous]')">{{ data.email }}</span>
            <button
              type="button"
              class="vt-info__email-status"
              *ngIf="showEmailEngagementStatus"
              [ngClass]="engagementStatusClass"
              [class.is-static]="!canOpenEmailStatusHistory"
              [attr.aria-disabled]="!canOpenEmailStatusHistory ? true : null"
              (click)="openSequenceHistoryFromEmail($event)">
              <i class="app-ico-mask" [ngClass]="engagementStatusIconClass"></i>
              {{ engagementStatusLabel | translate }}
            </button>
          </div>
        </div>

        <div class="vt-info__details__item contact-row" *ngIf="data.phone?.phoneNumber">
          <div class="vt-info__details__item__title">
            <i class="app-ico app-ico__phone"></i>{{ 'Common.Phone' | translate }}
          </div>
          <div class="vt-info__details__item__value" [class.is-anonymous]="data.phone?.phoneNumber.includes('[anonymous]')">
            <ng-container *ngIf="!data.phone?.phoneNumber.includes('[anonymous]')">
              <ng-container *ngTemplateOutlet="contactCapsule; context: {
                detail: 'phone', label: 'Phone number',
                value: ((data.phone?.countryCode || '') + ' ' + data.phone?.phoneNumber).trim(),
                viewed: data.isPhoneNumberViewed !== false, loading: viewingPhone
              }"></ng-container>
            </ng-container>
            <span *ngIf="data.phone?.phoneNumber.includes('[anonymous]')">{{ data.phone?.phoneNumber }}</span>
          </div>
        </div>

        <div class="vt-info__details__item" *ngIf="data.socialMedia?.telegram">
          <div class="vt-info__details__item__title">
            <i class="app-ico app-ico__social-telegram"></i>{{ 'VacancyTalentInfo.Telegram' | translate }}
          </div>
          <div class="vt-info__details__item__value" [class.is-anonymous]="data.socialMedia?.telegram.includes('[anonymous]')">
            {{ data.socialMedia?.telegram }}
          </div>
        </div>
      </ng-container>

      <p *ngIf="contactError" class="contact-reveal-error" role="alert">{{ contactError }}</p>

      <div class="vt-info__details__item" *ngIf="data.relocationPossibility">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__relocation"></i>{{ 'VacancyTalentInfo.Relocation' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.relocationPossibility | relocation }}
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="data.educationDegree || data.educationField">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__education"></i>{{ 'Common.Education' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          <span *ngIf="data.educationDegree">
            {{ data.educationDegree }} -
          </span>
          <span *ngIf="data.educationField">
            {{ data.educationField }}
          </span>
        </div>
      </div>

      <div class="vt-info__details__item"
        *ngIf="data.languages && data.languages.length && data.languages[0] && data.languages[0].name">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__language"></i>{{ 'Common.Language' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          <div *ngFor="let lang of data.languages">
            {{ lang.name }} <span *ngIf="lang.level">- {{ lang.level }}</span>
          </div>
        </div>
      </div>

      <div class="vt-info__details__item" *ngIf="!isVacancy && data.created">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__calendar"></i>{{ (data?.showAppliedDate ? 'VacancyTalentInfo.AppliedDate' : 'MatchItem.Created') | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.created | date: 'dd.MM.yy' }}
        </div>
      </div>
    </div>

    <div class="vt-info__details"
      *ngIf="!isVacancy && (data.preferredCompanyType || normalizeNullArray(data.domainsRequired).isValid || data.preferredCompanySize)">
      <h4>{{ 'VacancyTalentInfo.PreferredCompany' | translate }}</h4>
      <div class="vt-info__details__item" *ngIf="data.preferredCompanyType">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__work"></i>{{ 'Common.Type' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.preferredCompanyType }}
        </div>
      </div>
      <div class="vt-info__details__item" *ngIf="normalizeNullArray(data.domainsRequired).isValid">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__domain"></i>{{ 'VacancyTalentInfo.Domain' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          <div *ngFor="let domain of normalizeNullArray(data.domainsRequired).value">
            {{ domain }}
          </div>
        </div>
      </div>
      <div class="vt-info__details__item" *ngIf="data.preferredCompanySize">
        <div class="vt-info__details__item__title">
          <i class="app-ico-mask app-ico-mask__company-size"></i>{{ 'VacancyTalentInfo.Size' | translate }}
        </div>
        <div class="vt-info__details__item__value">
          {{ data.preferredCompanySize }}
        </div>
      </div>
    </div>

    <div class="vt-info__list-2 has-separator" *ngIf="!isVacancy && data.hardSkills && data.hardSkills.length">
      <h4>{{ 'Common.HardSkills' | translate }}</h4>
      <ul>
        <ng-container *ngFor="let skill of displayHardSkills">
          <li>
            <div class="is-skill-item" [class.is-matched]="isVacancySkill(skill.name)">
              <div class="is-skill-title">
                <span><b>{{ skill.name }}</b></span>
                <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
                <ng-container *ngIf="getSkillData(skill.name) as branchData">
                <badges-count *ngIf="validatedSkills && validatedSkills.length "
                  [validSkills]="[branchData]">
                </badges-count>
                </ng-container>
              </div>
              <div class="is-exp-dots">
                <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
                </span>

              </div>
            </div>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="vt-info__list-2 has-separator" *ngIf="isVacancy && (skillsMust.length || skillsNice.length)">
      <h4 *ngIf="skillsMust.length || skillsNice.length">{{ 'Common.HardSkills' | translate }}</h4>
      <div *ngIf="skillsMust && skillsMust.length">
        <div class="vt-info__section__sub-title">{{ 'VacancyTalentInfo.MustHave' | translate }}</div>
        <ul>
          <li *ngFor="let skill of skillsMust">
            <b>{{ skill.name }}</b>
            <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="skillsShouldHave && skillsShouldHave.length">
        <div class="vt-info__section__sub-title">{{ 'VacancyTalentInfo.ShouldHave' | translate }}</div>
        <ul>
          <li *ngFor="let skill of skillsShouldHave">
            <b>{{ skill.name }}</b>
            <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="skillsCouldHave && skillsCouldHave.length">
        <div class="vt-info__section__sub-title">{{ 'VacancyTalentInfo.CouldHave' | translate }}</div>
        <ul>
          <li *ngFor="let skill of skillsCouldHave">
            <b>{{ skill.name }}</b>
            <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="skillsNice && skillsNice.length">
        <div class="vt-info__section__sub-title">{{ 'VacancyTalentInfo.NiceToHave' | translate }}</div>
        <ul>
          <li *ngFor="let skill of skillsNice">
            <b>{{ skill.name }}</b>
            <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div *ngIf="skillsLowPriority && skillsLowPriority.length">
        <div class="vt-info__section__sub-title">{{ 'VacancyTalentInfo.LowPriority' | translate }}</div>
        <ul>
          <li *ngFor="let skill of skillsLowPriority">
            <b>{{ skill.name }}</b>
            <span *ngIf="skill.years"> - {{ skill.years }} {{ skill.years === 1 ? ('Common.Yr' | translate) : ('Common.Yrs' | translate) }}</span>
            <div class="is-exp-dots">
              <span *ngFor="let e of [].constructor(5); let i = index" [class.is-active]="i < skill.experience">
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="vt-info__list-2 has-separator" *ngIf="isVacancy && data.domainsRequired && data.domainsRequired.length">
      <h4>{{ 'VacancyTalentInfo.RequiredDomainsExperience' | translate }}</h4>
      <ul>
        <li *ngFor="let name of data.domainsRequired">{{ name }}</li>
      </ul>
    </div>

    <div class="vt-info__section has-separator vt-info__verification-summary" *ngIf="uanVerification">
      <h4 class="vt-info__section-title">{{ 'EmploymentVerification.Title' | translate }}</h4>
      <span class="vt-info__uan-badge vt-info__uan-badge--{{ getUanStatusClass(uanVerification.status) }}">
        <svg class="vt-info__uan-badge-icon" viewBox="0 0 16 18" aria-hidden="true">
          <path class="vt-info__uan-shield-outline" d="M8 1.7L13.2 3.55V8.15C13.2 11.35 11.15 14.35 8 16.1C4.85 14.35 2.8 11.35 2.8 8.15V3.55L8 1.7Z"></path>
          <path class="vt-info__uan-shield-divider" d="M8 2.65V15.15"></path>
        </svg>
        {{ getUanStatusKey(uanVerification.status) | translate }}
        <span class="vt-info__verification-info" *ngIf="uniqueUanReasons.length" tabindex="0">i</span>
        <span class="vt-info__verification-tooltip" *ngIf="uniqueUanReasons.length" role="tooltip">
          <span *ngFor="let reason of uniqueUanReasons">{{ getUanReasonLabel(reason) }}</span>
        </span>
      </span>
      <p class="vt-info__verification-summary__last-checked" *ngIf="uanVerification.lastChecked">
        {{ 'EmploymentVerification.LastChecked' | translate }} {{ uanVerification.lastChecked | date: 'dd MMM yyyy' }}
      </p>
      <p class="vt-info__verification-summary__failed" *ngIf="uanVerification.status === 'NotAvailable' && !uniqueUanReasons.length">
        {{ 'EmploymentVerification.CouldNotBeCompleted' | translate }}
      </p>
      <p class="vt-info__verification-summary__epfo" *ngFor="let employer of uanVerification.additionalEmployers || []">
        {{ getAdditionalEmployerText(employer) }}
      </p>
    </div>

    <div class="vt-info__section has-separator" *ngIf="data.workExperiences?.length">
      <h4 class="vt-info__section-title">{{ 'VacancyTalentInfo.Workplaces' | translate }}</h4>
      <div
        class="vt-info__section__work"
        *ngFor="let work of data.workExperiences"
        [class.has-uan-warning]="work.verification && !work.verification.isVerified">
        <ng-container *ngIf="work.companyName || work.jobTitle">
          <div class="vt-info__section__sub-title" [class.is-anonymous]="work.companyName?.includes('[anonymous]')">
            {{ work.jobTitle }}<span *ngIf="work.jobTitle && work.companyName">,</span> {{ work.companyName |
            randomText: work.companyName?.includes('[anonymous]') }}
            <span
              *ngIf="work.verification"
              class="vt-info__work-verification vt-info__work-verification--{{ getWorkVerificationClass(work.verification) }}">
              <span
                class="vt-info__work-verification-icon"
                [class.is-shield]="work.verification.isVerified"
                aria-hidden="true">
                <svg *ngIf="work.verification.isVerified" viewBox="0 0 16 18">
                  <path class="vt-info__uan-shield-outline" d="M8 1.7L13.2 3.55V8.15C13.2 11.35 11.15 14.35 8 16.1C4.85 14.35 2.8 11.35 2.8 8.15V3.55L8 1.7Z"></path>
                  <path class="vt-info__uan-shield-divider" d="M8 2.65V15.15"></path>
                </svg>
                <svg *ngIf="!work.verification.isVerified" class="vt-info__work-verification-warning" viewBox="0 0 16 14" aria-hidden="true">
                  <path d="M8 1.25 15 12.75H1L8 1.25Z"></path>
                  <path d="M8 5V8.5"></path>
                  <circle cx="8" cy="10.75" r=".75"></circle>
                </svg>
              </span>
              {{ getWorkVerificationLabelKey(work.verification) | translate }}
            </span>
          </div>
          <p class="vt-info__work-verification-epfo" *ngIf="work.verification?.epfoCurrentEmployer">
            {{ getEpfoCurrentEmployerText(work.verification.epfoCurrentEmployer) }}
          </p>
          <p class="vt-info__work-verification-epfo" *ngIf="work.verification?.epfo">
            {{ getEpfoEmploymentText(work.verification.epfo) }}
          </p>
          <div class="vt-info__section__work__dates">
            <span *ngIf="work.startMonth">{{ work.startMonth }}</span>
            <span *ngIf="work.startYear">{{ work.startYear }}</span>
            <span *ngIf="work.endMonth || work.endYear || work.isCurrentJob">-</span>
            <ng-container *ngIf="work.isCurrentJob">
              <span>{{ 'VacancyTalentInfo.CurrentWork' | translate }}</span>
            </ng-container>
            <ng-container *ngIf="!work.isCurrentJob">
              <span *ngIf="work.endMonth">{{ work.endMonth }}</span>
              <span *ngIf="work.endYear">{{ work.endYear }}</span>
            </ng-container>
          </div>
          <div class="vt-info__section__work__desc" *ngIf="work.description" [innerHTML]="work.description | safeHtml">
          </div><br>
        </ng-container>
      </div>
    </div>


    <div class="vt-info__section" *ngIf="data.about && data.about.achievements">
      <h4>{{ 'VacancyTalentInfo.Achievements' | translate }}</h4>
      <div [innerHTML]="data.about.achievements | safeHtml"></div>
    </div>

    <div class="vt-info__section" *ngIf="data.about && data.about.characteristics">
      <h4>{{ 'VacancyTalentInfo.PersonalCharacteristics' | translate }}</h4>
      <div [innerHTML]="data.about.characteristics | safeHtml"></div>
    </div>

    <!-- Educations: merged list from the API (CV-parsed entries, or one entry built from
         the Naukri/RocketReach flat fields). Falls back to the legacy flat fields when absent. -->
    <div class="vt-info__section has-separator" *ngIf="data.educations?.length; else legacyEducation">
      <h4>{{ 'Common.Education' | translate }}</h4>
      <div class="vt-info__section__work" *ngFor="let edu of data.educations">
        <div class="vt-info__section__sub-title" *ngIf="edu.issuingOrganization">{{ edu.issuingOrganization }}</div>
        <div class="vt-info__section__work__dates" *ngIf="edu.startYear || edu.endYear || edu.isCurrent">
          <span *ngIf="edu.startYear">{{ edu.startYear }}</span>
          <span *ngIf="edu.startYear && (edu.endYear || edu.isCurrent)">-</span>
          <span *ngIf="edu.isCurrent">{{ 'VacancyTalentInfo.CurrentStudy' | translate }}</span>
          <span *ngIf="!edu.isCurrent && edu.endYear">{{ edu.endYear }}</span>
        </div>
        <div class="vt-info__section__education__desc" *ngIf="edu.description">{{ edu.description }}</div>
        <br>
      </div>
    </div>

    <ng-template #legacyEducation>
      <div class="vt-info__section" *ngIf="data.educationDescription">
        <h4>{{ 'Common.Education' | translate }}</h4>
        <div *ngIf="data.educationDegree || data.educationField">
          <em>
            <span *ngIf="data.educationDegree">{{ data.educationDegree }}</span>
            <span *ngIf="data.educationDegree && data.educationField">, </span>
            <span *ngIf="data.educationField">{{ data.educationField }}</span>
          </em>
        </div>
        <div [innerHTML]="data.educationDescription | safeHtml"></div>
      </div>
    </ng-template>

    <div class="vt-info__section" *ngIf="data.description">
      <h4>{{ 'VacancyTalentInfo.AboutThePosition' | translate }}</h4>
      <div [innerHtml]="data.description | safeHtml"></div>
    </div>

    <div class="vt-info__section" *ngIf="data.responsibilities">
      <h4>{{ 'VacancyTalentInfo.MainResponsibilities' | translate }}</h4>
      <div [innerHtml]=" data.responsibilities | safeHtml"></div>
    </div>

    <div class="vt-info__section" *ngIf="data.company && data.company.about">
      <h4>{{ 'VacancyTalentInfo.AboutTheCompany' | translate }}</h4>
      <div [innerHTML]="data.company.about | safeHtml"></div>
    </div>

    <div class="vt-info__section" *ngIf="hasValidSocialMedia()">
      <h4>{{ 'VacancyTalentInfo.CompanySocialMedia' | translate }}</h4>
      <div class="vt-info__section__socials">
          <ng-container *ngFor="let media of data.company.socialMedia">
          <a *ngIf="media.url" [href]="media.url | urlHttps" target="_blank">
            <i [ngClass]="'app-ico app-ico__social-' + media.name.toLowerCase()"></i>
            {{ media.name }}
          </a>
        </ng-container>
      </div>
    </div>

    <div class="vt-info__section" *ngIf="(data.defaultCv && data.defaultCv.fileUrl) || 
        (data.socialMedia && (
        data.socialMedia.dribble || 
        data.socialMedia.gitHub || 
        data.socialMedia.linkedIn ||
        data.socialMedia.website ||
        data.socialMedia.stackOverflow))">
      <h4>{{ 'VacancyTalentInfo.ResumeAndLinks' | translate }}
        <span *ngIf="data.defaultCv && data.defaultCv.fileUrl && data.defaultCv.fileUrl === '[anonymous]'">*</span>
      </h4>
      <div *ngIf="data.defaultCv && data.defaultCv.fileUrl && data.defaultCv.fileUrl === '[anonymous]'">
        {{ 'VacancyTalentInfo.TalentCvUnavailable' | translate }}
      </div>
      <div class="vt-info__download-cv" *ngIf="data.defaultCv && data.defaultCv.fileUrl">
        <div class="is-btn is-btn__outfill" [class.is-disabled]="data.defaultCv.fileUrl === '[anonymous]'"
          (click)="download(data.defaultCv)">
          {{ 'VacancyTalentInfo.DownloadTalentCv' | translate }}
        </div>
      </div>
      <div class="vt-info__section__socials">
        <a *ngIf="data.socialMedia.linkedIn" [class.is-anonymous]="data.socialMedia.linkedIn.includes('[anonymous]')"
          (click)="trackAnalyticsEvent(RecruiterActivityEventType.CandidateLinkedinClicked)"
          [href]="!data.socialMedia.linkedIn.includes('[anonymous]') ? (data.socialMedia.linkedIn | urlHttps) : null" 
          [target]="!data.socialMedia.linkedIn.includes('[anonymous]') ? '_blank' : null"
          [style.cursor]="data.socialMedia.linkedIn.includes('[anonymous]') ? 'default' : 'pointer'"
          [style.pointer-events]="data.socialMedia.linkedIn.includes('[anonymous]') ? 'none' : 'auto'">
          <i class="app-ico app-ico__social-linkedin"></i> LinkedIn
        </a>
        <a *ngIf="data.socialMedia.gitHub" [class.is-anonymous]="data.socialMedia.gitHub.includes('[anonymous]')"
          (click)="trackAnalyticsEvent(RecruiterActivityEventType.CandidateGithubClicked)"
          [href]="!data.socialMedia.gitHub.includes('[anonymous]') ? (data.socialMedia.gitHub | urlHttps) : null" target="_blank">
          <i class="app-ico app-ico__social-github"></i> GitHub
        </a>
        <a *ngIf="data.socialMedia.stackOverflow"
          (click)="trackAnalyticsEvent(RecruiterActivityEventType.CandidateStackoverflowClicked)"
          [class.is-anonymous]="data.socialMedia.stackOverflow.includes('[anonymous]')"
          [href]="!data.socialMedia.stackOverflow.includes('[anonymous]') ? (data.socialMedia.stackOverflow | urlHttps) : null" target="_blank">
          <i class="app-ico app-ico__social-stackoverflow"></i> Stack Overflow
        </a>
        <a *ngIf="data.socialMedia.dribble" [class.is-anonymous]="data.socialMedia.dribble.includes('[anonymous]')"
          (click)="trackAnalyticsEvent(RecruiterActivityEventType.CandidateDribbleClicked)"
          [href]="!data.socialMedia.dribble.includes('[anonymous]') ? (data.socialMedia.dribble | urlHttps) : null" target="_blank">
          <i class="app-ico app-ico__social-dribble"></i> Dribble
        </a>
        <a *ngIf="data.socialMedia.website" [class.is-anonymous]="data.socialMedia.website.includes('[anonymous]')"
          (click)="trackAnalyticsEvent(RecruiterActivityEventType.CandidateWebsiteClicked)"
          [href]="!data.socialMedia.website.includes('[anonymous]') ? (data.socialMedia.website | urlHttps) : null" target="_blank">
          <i class="app-ico app-ico__social-website"></i> Website
        </a>
      </div>
    </div>

  </div>
</div>


<ng-template #contactCapsule let-detail="detail" let-label="label" let-value="value"
  let-viewed="viewed" let-loading="loading">
  <div class="contact-capsule" [class.contact-capsule--revealed]="viewed"
    [attr.aria-busy]="loading">
    <span *ngIf="viewed" class="contact-capsule__value" [title]="value">{{ value }}</span>
    <span *ngIf="!viewed" class="contact-capsule__value contact-capsule__value--masked">{{ value.split('******')[0] }}<span class="contact-capsule__dots">&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;</span>{{ value.split('******')[1] }}</span>
    <button *ngIf="!viewed" type="button" class="contact-capsule__action contact-capsule__eye"
      [class.is-loading]="loading"
      [disabled]="loading || viewingEmail || viewingPhone || copyingContact || !data.contactVacancyId"
      [attr.aria-label]="'View ' + label.toLowerCase()" [title]="'View ' + label.toLowerCase()"
      (click)="viewContact(detail)">
      <i *ngIf="!loading" class="app-ico-mask app-ico-mask__eye" aria-hidden="true"></i>
      <div *ngIf="loading" style="position: relative; width: 20px; height: 20px;">
        <div class="round-loader is-trans"></div>
      </div>
    </button>
    <span *ngIf="viewed" class="contact-capsule__actions">
      <button type="button" class="contact-capsule__action" (click)="copyContact(detail)"
        [disabled]="copyingContact || viewingEmail || viewingPhone"
        [attr.aria-label]="copiedContact === detail ? 'Copied' : 'Copy ' + label.toLowerCase()"
        [title]="copiedContact === detail ? 'Copied' : 'Copy ' + label.toLowerCase()">
        <i class="app-ico-mask" [class.app-ico-mask__copy]="copiedContact !== detail"
          [class.app-ico-mask__check-circle]="copiedContact === detail" aria-hidden="true"></i>
      </button>

    </span>
  </div>
  
</ng-template>
